import { Grid2, useTheme } from '@mui/material';
import { Menubar } from './Menubar.tsx';
import { Sidebar } from './sidebar/Sidebar.tsx';
import { Footer } from './Footer.tsx';
import { Outlet, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { getSubRoutesFromUrl } from '../routes';

export const AppLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const theme = useTheme();

  const location = useLocation();
  const routes = getSubRoutesFromUrl(location.pathname);

  return (
    <Grid2 container sx={{ width: '100vw', height: '100vh' }}>
      <Grid2
        size={2}
        sx={{ borderRight: `1px solid ${theme.palette.grey[100]} `, backgroundColor: 'white', height: `calc(100vh - ${theme.spacing(7)})`, overflow: 'scroll' }}
      >
        {routes && <Menubar routes={routes} />}
      </Grid2>
      <Grid2
        size={isSidebarOpen ? 8 : 9.5}
        sx={{
          height: `calc(100vh - ${theme.spacing(7)})`,
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Outlet />
      </Grid2>
      <Grid2
        size={isSidebarOpen ? 2 : 0.5}
        sx={{
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          borderLeft: `1px solid ${theme.palette.grey[100]}`,
          backgroundColor: 'white',
          minHeight: `calc(100vh - ${theme.spacing(7)})`,
        }}
      >
        <Sidebar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} isSidebarOpen={isSidebarOpen} />
      </Grid2>
      <Grid2 size={12} sx={{ height: theme.spacing(7) }}>
        <Footer />
      </Grid2>
    </Grid2>
  );
};
